import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	card: {
		borderRadius: theme.radius.md,
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
	},
	imageContainer: {
		width: '100%',
		height: '100px',
		overflow: 'hidden',
	},
	actionIcon: {
		position: 'absolute',
		top: theme.spacing.md,
		right: theme.spacing.md,
		borderRadius: theme.other.borderRadius.sm,
		backgroundColor: theme.other.getColor('fill/transparent/default'),
		'&:hover': {
			backgroundColor: theme.other.getColor('fill/transparent/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('fill/transparent/active'),
		},
		transition: 'background-color 0.2s ease-in-out',
	},
}));
